
/**
* Renders a skeleton placeholder for the challenge detail page while content loads.
* @example
* ChallengeDetailPageSkeleton()
* <div className="min-h-screen bg-background-primary animate-pulse">...</div>
* @param {void} _ - No arguments are required.
* @returns {JSX.Element} Placeholder layout that mimics the challenge detail structure.
**/
const ChallengeDetailPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background-primary animate-pulse">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-6">
          <div className="h-10 bg-background-tertiary rounded w-64 mb-4" />
          <div className="flex gap-4 mb-4">
            <div className="h-6 bg-background-tertiary rounded w-24" />
            <div className="h-6 bg-background-tertiary rounded w-32" />
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-background-secondary rounded-lg p-4 border border-border-primary">
              <div className="h-4 bg-background-tertiary rounded w-20 mb-2" />
              <div className="h-8 bg-background-tertiary rounded w-16" />
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="bg-background-secondary rounded-lg p-6 border border-border-primary">
          <div className="h-6 bg-background-tertiary rounded w-32 mb-4" />
          <div className="space-y-2 mb-6">
            <div className="h-4 bg-background-tertiary rounded w-full" />
            <div className="h-4 bg-background-tertiary rounded w-5/6" />
          </div>

          {/* Problems */}
          <div className="space-y-3">
            {[1, 2].map((i) => (
              <div key={i} className="bg-background-primary rounded p-4 border border-border-primary">
                <div className="h-5 bg-background-tertiary rounded w-3/4" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeDetailPageSkeleton;
